import Overlay from './src/overlay'

export const SgOverlay = Overlay
export default SgOverlay

export * from './src/overlay'
